import { SessionService } from 'src/app/services/session.service';
// import { ToastrService } from 'ngx-toastr';
import {
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpEvent
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { AppStateService } from '../services/app-state.service';
import { SDKErrorResponse } from '../models/sdk-error-response.model';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private appState: AppStateService,
    // private toastr: ToastrService,
    private session: SessionService,) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((error, caught) => {
      this.handleAuthError(error);
      return of(Error);
    }) as any);
  }

  handleAuthError(err: HttpErrorResponse) {
    // Pegar erros na requisição
    if (err.error.error) {
      this.appState.setResponseResult(new SDKErrorResponse(false, err.error.error));
    }

    switch (err.status) {
      case 200:
        // msg = await this.traducao.get('erros.200');
        // this.toastr.success('Operação realizada com sucesso');
        break;
      case 400:
        // this.toastr.error(err.error.erros.message);
        break;
      case 401:
        // this.toastr.error('Faça login novamente para continuar');
        sessionStorage.clear();
        this.router.navigate(['']);
        break;
      case 403:
        // this.toastr.error('Você não possui permissão para executar esta ação');
        sessionStorage.clear();
        this.router.navigate(['']);
        break;
      case 404:
        // msg = await this.traducao.get('erros.404');
        // this.toastr.error('Dados não encontrados');
        break;
      case 409:
        // this.toastr.error('Email já cadastrado');
        break;
      case 426:
        // this.toastr.error('Limite excedido, entre em contato com o suporte');
        break;
      case 500:
        // msg = await this.traducao.get('erros.500');
        // this.toastr.error('Erro no servidor');
        break;
      case 501:
        // msg = await this.traducao.get('erros.501');
        // this.toastr.error('Erro no servidor');
        break;
      default:
        // msg = await this.traducao.get('erros.default');
        // this.toastr.error('Ocorreu um erro, tente novamente');
        break;
    }
    throw Error;
  }
}
